import { Map, List } from 'immutable';
import moment from 'moment';
import { appDb } from 'nike-re-framejs';

import { DEFAULT_INTERVAL, INTERVALS } from '../components/dialog/byDate';

export function appliesOfferFilter(filter, section) {
    return filter.getIn(['offer', section]) === true;
}

function ensureBoxMarkets(boxIds, filter) {
    let markets = filter.get('selectedMarkets', Map());

    // defenzivny check aby sa neloadoval market, ktory nie je v otvorenom boxe
    if (boxIds && !boxIds.isEmpty()) {
        markets = markets.filter((marketIds, boxId) => boxIds.has(boxId));
    }
    return markets.filter(market => market.size);
}

const superBoxy = ['top5', 'superoffer', 'superchance', 'naj10'];

function ensureSuperBoxes(boxIds) {
    let superIds = boxIds.filter(boxId => superBoxy.indexOf(boxId) > -1);
    if (superIds.length || superIds.size) {
        return [superIds, true];
    }
    return [boxIds, false];
}

function computeBoxIds(desiredBoxIds, filter) {
    const markets = ensureBoxMarkets(desiredBoxIds, filter);
    // PRAVIDLO boxId + boxMarket
    // ak chceme default market pre box: 'boxId=bi-1-97-t:953'
    // ak chceme iny market pre box: 'boxMarket=bi-1-97-t:953||urn:be:market:3675'
    // sluzba neumoznuje kombinovat rovnaky box zaroven v parametroch 'boxId' aj 'boxMarket'!
    const marketBoxIds = markets.keySeq().toSet();
    const boxIds = desiredBoxIds.filter(id => !marketBoxIds.has(id));
    const boxMarkets = markets
        .map((marketIds, boxId) => marketIds.map(marketId => boxId + '||' + marketId))
        .valueSeq()
        .flatten();
    return [boxIds.toArray(), boxMarkets.toArray()];
}

// NOTE: tato filtracna funkcia nepodporuje, ak su oba paremetre isPrematch, isResults zaroven 'true'
function computeSportEventIds(boxIdsSet, isPrematch, isResults) {
    if (process.env.NODE_ENV !== 'production' && isPrematch && isResults) {
        throw Error('isPrematch as TRUE with isResults as TRUE is not supported right now');
    }
    const boxToSportEventsPath = isResults ? 'resultsBoxToSportEvents' : 'prematchBoxToSportEvents';
    return appDb
        .peekValue()
        .getIn(['ticketus', 'active', boxToSportEventsPath], Map())
        .filter((sportEvents, value) => boxIdsSet.has(value))
        .valueSeq()
        .flatten()
        .toSet()
        .toArray();
}

const isBeforeToday = byDate => {
    if (Array.isArray(byDate)) {
        return byDate.some(isBeforeToday);
    }
    return moment(byDate).isBefore(moment());
};

export function serializeDate(byDate, restrainToday) {
    if (!byDate) {
        byDate = DEFAULT_INTERVAL;
    }
    if (restrainToday && byDate === DEFAULT_INTERVAL) {
        byDate = 'TODAY';
    }
    const params = {};
    const interval = INTERVALS[byDate];
    if (interval) {
        params.date = interval.date;
        params.minutes = interval.minutes;
    } else {
        params.date = byDate;
        if (isBeforeToday(byDate)) {
            params.live = false;
            params.prematch = false;
            params.results = true;
        }
    }
    return params;
}

export function makeBoxesRequestParam(desiredBoxIds, filter) {
    // PRAVIDLO superboxy
    // sluzba neumoznuju kombinovat superBoxy (top5, superoffer) a klasicke boxy
    // (ak medzi boxami najdeme superboxy => loaduju sa iba tie)
    let [boxIdsSet, isSuperBox] = ensureSuperBoxes(desiredBoxIds);

    const [boxIds, boxMarkets] = computeBoxIds(boxIdsSet, filter);
    let request = {
        boxId: boxIds,
        live: appliesOfferFilter(filter, 'live'),
        prematch: appliesOfferFilter(filter, 'prematch'),
        results: appliesOfferFilter(filter, 'results')
    };
    if (boxMarkets && boxMarkets.length) {
        request.boxMarket = boxMarkets;
    }

    // PRAVIDLO extendedMarkets
    // superboxy sa nemozu kombinovat s parametrom 'extendedMarkets=true'
    if (!isSuperBox && appliesOfferFilter(filter, 'extendedMarkets')) {
        request.extendedMarkets = true;
        request.shortcutMarkets = true;
    }

    request = Object.assign(request, serializeDate(filter.get('byDate'), filter.get('today')));

    // ak je zapnute ticketsOnly, prefiltrujeme sporeventami z ticketusu
    if (appliesOfferFilter(filter, 'tickets')) {
        request.sportEventId = computeSportEventIds(boxIdsSet, request.prematch, request.results);
    }
    if (appliesOfferFilter(filter, 'dates')) {
        request.date = [
            moment()
                .add(-7, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(365, 'days')
                .format('YYYY-MM-DD')
        ];
    }
    return request;
}

export function makeOnTicketsRequestParam(filter, sportEvents) {
    let request = {
        date: serializeDate(filter.get('byDate'), filter.get('today')),
        live: appliesOfferFilter(filter, 'live'),
        prematch: appliesOfferFilter(filter, 'prematch'),
        results: appliesOfferFilter(filter, 'results'),
        sportId: filter.get('onTicketSportId'),
        countryId: filter.get('onTicketCountryId'),
        sportEventId: sportEvents.toArray()
    };

    return Object.assign(request, serializeDate(filter.get('byDate'), filter.get('today')));
}

export function makeMenuRequestParam(db, boxStore) {
    const byDate = db.getIn(['nikeone', 'boxStore', boxStore, 'filter', 'byDate']);
    const request = db.getIn(['nikeone', 'boxStore', boxStore, 'filter', 'offer']).toJS();
    request.showMatchCounts = true;
    return Object.assign(request, serializeDate(byDate));
}

export function makeMatchesRequestParam(sportEventIds = List()) {
    return {
        live: true,
        prematch: true,
        results: true,
        sportEventId: sportEventIds.toArray()
    };
}
